
import { Component, OnInit, forwardRef, Input, Output, EventEmitter, AfterViewInit, OnChanges, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, AbstractControl, ValidationErrors, ControlValueAccessor, Validator, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormBuilder, FormControl, Validators } from '@angular/forms';
import { AgentService } from '../shared/services/agent.service';
import { ActivatedRoute } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { Languages, FormMode } from 'src/app/shared/models/enums.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ReplaySubject } from 'rxjs';
import { AgentCurrency } from '../shared/models/agent-currency.model';

@Component({
  selector: 'agent-basic-info',
  templateUrl: './agent-basic-info.component.html',
  styleUrls: ['./agent-basic-info.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AgentBasicInfoComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AgentBasicInfoComponent),
      multi: true
    }
  ]
})
export class AgentBasicInfoComponent implements OnInit, ControlValueAccessor, Validator/*, OnChanges*/ {
  agentInfoForm: FormGroup;

  dropdownSettings = {};
  public Languages: any = Languages;
  user: User = new User();
  responseObject: ResponseObject;
  UserId: string = '';
  genericLookupModel: GenericLookup[] = [];
  displayedLang: any;
  @Input() public FeesTabs: TabsetComponent;
  selectedCurrencyId: any;

  //@Input () public  tabOneControls: ElementRef;
  @Output() agentEvent = new EventEmitter<number>();

  @Input() public agentId: string;
  @Input() public currencyId: number;
  @Input() public FormMode: number;
  //isTabOneValid: boolean =false;;
  isTabOneSubmitted: boolean = false;
  getAgentCalled: boolean = false;
  @ViewChild('tabOneControls',{static: false}) tabOneControls: ElementRef;
  @Output() isTabOneValid = new EventEmitter<boolean>(false);
  constructor(private agentService: AgentService, private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private globalSrv: GlobalServices,
    private authSrevice: AuthenticationService
  ) {
    this.user = this.authSrevice.currentUserValue;
    this.displayedLang = this.globalSrv.getLanguage();


    this.agentService.listen().subscribe((m: any) => {
      this.agentId = m;

    });

  }

  ngOnInit() {
    this.buildForm();
   // if(!this.user.IsAdmin){  /// temp fix for currencyID  (Payment Currency - doesnot bind data in case of agent logined)
    //  if (!this.agentId) {
    //  this.agentId = this.user.UserId;
    //  }
    //  this.getAgent(this.agentId);
    //}
  }


  get f() {
    return this.agentInfoForm.controls;
  }

  buildForm() {
    this.agentInfoForm = this.formBuilder.group({
      name: new FormControl({ value: '', disabled: true }),
      Phone1: new FormControl({ value: '', disabled: true }),
      currencyId: new FormControl(null, Validators.required),
    });
  }

  //#region CVA starts

  public onTouched: () => void = () => { };

  writeValue(val: any): void {
    val && this.agentInfoForm.setValue(val, { emitEvent: false });
  }
  registerOnChange(fn: any): void {
    this.agentInfoForm.valueChanges.subscribe(fn);
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.agentInfoForm.disable() : this.agentInfoForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null {
    //return this.agentForm.valid ? null : { invalidForm: {valid: false, message: "agent form fields are invalid"}};
    return this.agentInfoForm.valid ? null : this.agentInfoForm.controls;
  }
  //#endregion

  public getAgent(agentId: string) {
    this.getAgentCalled = true; // This flag is set to true to prevent more calls of getAgent
    this.agentService.GetAgent(agentId).subscribe(
      (resObj: ResponseObject) => {

        this.responseObject = resObj;
        if (this.responseObject.Success) {
          this.agentInfoForm.patchValue({
            name: resObj.Data['Name'],
            Phone1: resObj.Data['Phone1'],

          });
          if (!resObj.Data.IsOffline) {
            resObj.Data.AgentCurrencies = resObj.Data.AgentCurrencies.filter(item => item.TreasuryNumber != null);
          }
          this.genericLookupModel = resObj.Data['AgentCurrencies'].map(function (obj) {
            return {
              Id: obj.Currency.Id,
              NameEN: obj.Currency.NameEN + "-" + obj.TreasuryNumber,
              NameAR: obj.Currency.NameAR + "-" + obj.TreasuryNumber,
            }

          });
          if (this.FormMode != FormMode.Add && this.currencyId) {
            this.agentInfoForm.patchValue({
              currencyId: this.currencyId
            });
            this.isTabOneValid.emit(true);
          }
          if (this.FormMode != FormMode.Readonly) {
            this.agentInfoForm.get('currencyId').enable();
            this.agentInfoForm.get('name')?.disable();
            this.agentInfoForm.get('Phone1').disable();
          }

          //this.agentLoadedFlag.emit(true);
        }
        else {
          // console.log("Fail");
        }
      });
  }

  // ngAfterViewInit() {
  //   if (!this.agentId) {
  //     this.agentId = this.user.UserId;
  //   }
  //   setTimeout(() => {
  //     this.getAgent(this.agentId);
  //   }, 1000);
  // }
  ngOnChanges() {
  //  if(this.user.IsAdmin){ /// temp fix for currencyID  (Payment Currency - doesnot bind data in case of agent logined)
   if (!this.agentId) {
      this.agentId = this.user.UserId;
    }
    if(!this.getAgentCalled && this.agentId != undefined){
      this.getAgent(this.agentId);
    }
 // }
  }

  ChangingCurrency(event) {
    this.selectedCurrencyId = event.target.value;
    if (this.selectedCurrencyId != 'null') {
      this.agentEvent.emit(this.selectedCurrencyId);
      this.isTabOneValid.emit(true);
    }
    else {
      this.isTabOneValid.emit(false);
    }
  }

  selectTab(tabId: number) {
    if (tabId == 1) {
      this.isTabOneSubmitted = true;
      if (!this.validateTabOne) {
        this.isTabOneValid.emit(true);
        this.FeesTabs.tabs[tabId].disabled = false;
        this.FeesTabs.tabs[tabId].active = true;
        this.FeesTabs.tabs[tabId + 1].disabled = true;
        this.FeesTabs.tabs[tabId + 1].active = false;
        const el = document.getElementsByClassName('section-title');
        el[0].scrollIntoView({ behavior: 'smooth' });
      }
      else {
        const invalidControls = this.tabOneControls.nativeElement.querySelectorAll('.ng-invalid');
        if (invalidControls.length > 0) {
          invalidControls[0].focus();
        }
        this.FeesTabs.tabs[tabId].disabled = true;
        this.FeesTabs.tabs[tabId].active = false;
        this.FeesTabs.tabs[tabId + 1].disabled = true;
        this.FeesTabs.tabs[tabId + 1].active = false;
      }
    }

  }


  get validateTabOne() {
    const isvalid = this.agentInfoForm.get('currencyId').invalid || this.agentInfoForm.get('currencyId').value == 'null';
    if (isvalid) {
      this.isTabOneValid.emit(false);
    }
    else {
      this.isTabOneValid.emit(true);
    }
    return isvalid;
  }

}
